import axios, { AxiosError } from 'axios'
import type { ApiError } from '../types'

export const TOKEN_KEY = 'vision-governance-token'

export const api = axios.create({
  baseURL: '/api',
  timeout: 120_000,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

let handlingUnauthorized = false
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiError>) => {
    if (
      error.response?.status === 401
      && localStorage.getItem(TOKEN_KEY)
      && !handlingUnauthorized
    ) {
      handlingUnauthorized = true
      localStorage.removeItem(TOKEN_KEY)
      window.dispatchEvent(new CustomEvent('governance:unauthorized'))
      window.setTimeout(() => {
        handlingUnauthorized = false
      }, 500)
    }
    return Promise.reject(error)
  },
)

export function apiErrorMessage(error: unknown, fallback = '请求失败，请稍后重试') {
  if (axios.isAxiosError<ApiError>(error)) {
    return error.response?.data?.detail || error.message || fallback
  }
  return error instanceof Error ? error.message : fallback
}
